export const translations = {
  // Page Metadata - Enhanced for SEO and AI Search
  pageTitle: {
    en: 'Taiwan Bank Code Directory 2026 - 410 Financial Institutions | Complete Banking Guide',
    zh: '台灣銀行代碼查詢系統 2026 - 410家金融機構完整目錄 | 銀行代碼大全',
  },
  pageDescription: {
    en: 'Comprehensive Taiwan bank code directory updated March 2026. Search 410 financial institutions including commercial banks, digital banks, credit cooperatives, farmers\' associations (農會), and fishermen\'s associations (漁會). Instant bilingual search with official bank codes.',
    zh: '台灣最完整的銀行代碼查詢系統（2026年3月更新），涵蓋410家金融機構：商業銀行、數位銀行、信用合作社、農會信用部（315家）、漁會信用部（21家）。提供即時雙語搜尋、智能分類、官方銀行代碼查詢。',
  },
  pageKeywords: {
    en: 'Taiwan bank codes 2026, bank code lookup, Taiwan banking directory, financial institution codes, 銀行代碼, SWIFT codes Taiwan, clearing codes, commercial banks Taiwan, digital banks, credit cooperatives, farmers association credit, fishermen association credit, 農會信用部, 漁會信用部, 信用合作社, CBC Taiwan, Central Bank codes, banking search Taiwan, financial directory',
    zh: '台灣銀行代碼2026, 銀行代碼查詢, 金融機構代碼, 銀行代碼大全, SWIFT代碼, 清算代碼, 商業銀行, 數位銀行, 信用合作社, 農會信用部, 漁會信用部, 中央銀行代碼, 台灣金融機構, 銀行目錄, 銀行搜尋, 金融代碼查詢, 匯款銀行代碼, 轉帳代碼',
  },

  // Header - Enhanced
  appTitle: {
    en: 'Taiwan Bank Code Directory',
    zh: '台灣銀行代碼查詢系統',
  },
  appSlogan: {
    en: 'Complete directory of 410 Taiwan financial institutions - Updated March 2026',
    zh: '涵蓋410家台灣金融機構的完整目錄 - 2026年3月更新',
  },

  // Search Section - Enhanced with AI-friendly terms
  searchLabel: {
    en: 'Search Taiwan Bank Codes',
    zh: '搜尋台灣銀行代碼',
  },
  searchPlaceholder: {
    en: 'Search by bank name, code, or institution type (e.g., 004, Taiwan Bank, 農會, 漁會)...',
    zh: '輸入銀行名稱、代碼或機構類型（例如：004、台灣銀行、農會、漁會）...',
  },
  clearSearch: {
    en: 'Clear search and reset filters',
    zh: '清除搜尋並重置篩選',
  },
  sortBy: {
    en: 'Sort Results By',
    zh: '結果排序方式',
  },
  sortByCode: {
    en: 'Bank Code (Numerical)',
    zh: '銀行代碼（數字）',
  },
  sortByName: {
    en: 'Institution Name (Alphabetical)',
    zh: '機構名稱（字母）',
  },
  sortStatus: {
    en: {
      code: {
        asc: 'Sorted by Bank Code (Ascending Order: 001-999)',
        desc: 'Sorted by Bank Code (Descending Order: 999-001)',
      },
      name: {
        asc: 'Sorted by Institution Name (A to Z)',
        desc: 'Sorted by Institution Name (Z to A)',
      },
    },
    zh: {
      code: {
        asc: '依銀行代碼升序排列（001-999）',
        desc: '依銀行代碼降序排列（999-001）',
      },
      name: {
        asc: '依機構名稱升序排列（A-Z / 筆劃）',
        desc: '依機構名稱降序排列（Z-A / 筆劃）',
      },
    },
  },

  // Quick Navigation - Enhanced with counts
  quickNavTitle: {
    en: 'Browse by Institution Category',
    zh: '依機構類型瀏覽',
  },
  quickNavSubtitle: {
    en: 'Quick access to 410 Taiwan financial institutions',
    zh: '快速查詢410家台灣金融機構',
  },

  // Category Names with Counts
  categoryCommercialBanks: {
    en: 'Commercial & Digital Banks (48)',
    zh: '商業銀行與數位銀行（48家）',
  },
  categoryCreditCooperatives: {
    en: 'Credit Cooperatives (21)',
    zh: '信用合作社（21家）',
  },
  categoryFarmersAssociations: {
    en: 'Farmers\' Associations Credit Dept. (315)',
    zh: '農會信用部（315家）',
  },
  categoryFishermenAssociations: {
    en: 'Fishermen\'s Associations Credit Dept. (21)',
    zh: '漁會信用部（21家）',
  },
  categoryOthers: {
    en: 'Other Financial Institutions (5)',
    zh: '其他金融機構（5家）',
  },

  // Results Section - Enhanced
  resultsTitle: {
    en: 'Search Results - Taiwan Bank Codes',
    zh: '搜尋結果 - 台灣銀行代碼',
  },
  resultsCount: {
    en: (count, total = 410) => `Showing ${count} of ${total} financial institutions`,
    zh: (count, total = 410) => `顯示 ${count} / ${total} 家金融機構`,
  },
  resultsFiltered: {
    en: (count, category) => `Found ${count} institutions in ${category}`,
    zh: (count, category) => `在「${category}」類別中找到 ${count} 家機構`,
  },
  noResults: {
    en: 'No financial institutions found matching your search criteria. Please try different keywords such as bank name, code number, or institution type (e.g., "農會" for farmers\' associations, "漁會" for fishermen\'s associations).',
    zh: '找不到符合搜尋條件的金融機構。請嘗試不同的關鍵字，例如銀行名稱、代碼數字，或機構類型（如「農會」、「漁會」、「信用合作社」）。',
  },
  noResultsSuggestions: {
    en: 'Search suggestions: Try "004" for Taiwan Bank, "700" for Postal Savings, "農會" for farmers\' associations, or "信用合作社" for credit cooperatives.',
    zh: '搜尋建議：試試「004」查詢台灣銀行、「700」查詢郵政儲金、「農會」查詢農會信用部，或「信用合作社」查詢信合社。',
  },

  // Bank Table Headers - Enhanced
  thCode: {
    en: 'Bank Code',
    zh: '銀行代碼',
  },
  thNameEn: {
    en: 'Institution Name (English)',
    zh: '機構名稱（英文）',
  },
  thNameZh: {
    en: 'Institution Name (Traditional Chinese)',
    zh: '機構名稱（繁體中文）',
  },
  thCategory: {
    en: 'Institution Type',
    zh: '機構類型',
  },

  // Mobile View Labels - Enhanced
  mobileLabelCode: {
    en: 'Code',
    zh: '代碼',
  },
  mobileLabelType: {
    en: 'Type',
    zh: '類型',
  },
  mobileLabelSwift: {
    en: 'SWIFT',
    zh: 'SWIFT',
  },
  
  // Pagination - Enhanced
  paginationItemsPerPage: {
    en: 'Show per page:',
    zh: '每頁顯示：',
  },
  paginationPage: {
    en: 'Page',
    zh: '第',
  },
  paginationOf: {
    en: 'of',
    zh: '頁，共',
  },
  paginationTotal: {
    en: (total) => `${total} pages total`,
    zh: (total) => `總共 ${total} 頁`,
  },
  paginationShowing: {
    en: (start, end, total) => `Showing ${start}-${end} of ${total} institutions`,
    zh: (start, end, total) => `顯示第 ${start}-${end} 筆，共 ${total} 家機構`,
  },

  // About Section - Comprehensive SEO-friendly content
  aboutTitle: {
    en: 'About Taiwan Bank Code Directory System',
    zh: '關於台灣銀行代碼查詢系統',
  },
  aboutDescription: {
    en: 'The Taiwan Bank Code Directory is the most comprehensive and up-to-date resource for Taiwan financial institution codes. Updated March 2026, our directory covers all 410 financial institutions operating in Taiwan, including commercial banks, digital banks, credit cooperatives (信用合作社), farmers\' association credit departments (農會信用部 - 315 institutions), and fishermen\'s association credit departments (漁會信用部 - 21 institutions). All bank codes are officially verified and comply with Taiwan\'s Central Bank standards.',
    zh: '台灣銀行代碼查詢系統是最完整、最新的台灣金融機構代碼資源庫。2026年3月更新版本涵蓋全台410家金融機構，包括商業銀行、數位銀行、信用合作社（21家）、農會信用部（315家）、漁會信用部（21家）。所有銀行代碼均經官方驗證，符合中華民國中央銀行標準。',
  },
  aboutFeatures: {
    en: 'Key Features & Capabilities',
    zh: '主要功能與特色',
  },
  feature1: {
    en: '🔍 Instant Search: Search by bank name (English/Chinese), bank code, or institution type with real-time results',
    zh: '🔍 即時搜尋：支援銀行名稱（中英文）、銀行代碼、機構類型的即時搜尋',
  },
  feature2: {
    en: '🏦 Complete Coverage: 410 financial institutions including all commercial banks, digital banks, credit cooperatives, farmers\' and fishermen\'s associations',
    zh: '🏦 完整涵蓋：410家金融機構，包含所有商業銀行、數位銀行、信用合作社、農會及漁會信用部',
  },
  feature3: {
    en: '🏷️ Smart Categorization: Taiwan-specific classification system for easy navigation by institution type',
    zh: '🏷️ 智能分類：台灣專用分類系統，可依機構類型快速導航',
  },
  feature4: {
    en: '📱 Responsive Design: Optimized for desktop, tablet, and mobile devices with touch-friendly interface',
    zh: '📱 響應式設計：針對桌機、平板、手機優化，提供觸控友善介面',
  },
  feature5: {
    en: '🌐 Bilingual Interface: Full support for Traditional Chinese and English with seamless language switching',
    zh: '🌐 雙語介面：完整支援繁體中文與英文，可無縫切換語言',
  },
  feature6: {
    en: '⚡ High Performance: Lightning-fast search with <100ms response time, handling 410 institutions effortlessly',
    zh: '⚡ 高效能：閃電般的搜尋速度，<100ms 回應時間，輕鬆處理410家機構資料',
  },
  feature7: {
    en: '🌙 Dark Mode: Eye-friendly dark theme for comfortable viewing in low-light environments',
    zh: '🌙 深色模式：護眼深色主題，適合低光環境舒適閱讀',
  },
  feature8: {
    en: '♿ Accessibility: WCAG 2.1 AA compliant with keyboard navigation and screen reader support',
    zh: '♿ 無障礙設計：符合 WCAG 2.1 AA 標準，支援鍵盤導航與螢幕閱讀器',
  },
  
  // Institution Types Explained
  institutionTypesTitle: {
    en: 'Taiwan Financial Institution Types',
    zh: '台灣金融機構類型說明',
  },
  typeCommercialBanks: {
    en: 'Commercial Banks: Traditional and digital banks offering comprehensive financial services (48 institutions)',
    zh: '商業銀行：提供全方位金融服務的傳統銀行與數位銀行（48家）',
  },
  typeCreditCooperatives: {
    en: 'Credit Cooperatives (信用合作社): Community-based financial institutions serving local members (21 institutions)',
    zh: '信用合作社：以社區為基礎，服務地方會員的金融機構（21家）',
  },
  typeFarmersAssociations: {
    en: 'Farmers\' Association Credit Departments (農會信用部): Agricultural finance specialists serving farming communities across Taiwan (315 institutions)',
    zh: '農會信用部：專注農業金融，服務全台農村社區的專業機構（315家）',
  },
  typeFishermenAssociations: {
    en: 'Fishermen\'s Association Credit Departments (漁會信用部): Fishery finance specialists supporting coastal and fishing communities (21 institutions)',
    zh: '漁會信用部：專注漁業金融，支援沿海及漁業社區的專業機構（21家）',
  },
  
  // Data Source & Accuracy
  dataSourceTitle: {
    en: 'Data Source & Verification',
    zh: '資料來源與驗證',
  },
  dataSource: {
    en: 'All bank codes and institution information are sourced from official Taiwan financial regulatory authorities, including the Central Bank of the Republic of China (Taiwan) and the Financial Supervisory Commission. Our database is regularly updated to ensure 100% accuracy and completeness. Last verified: March 2026.',
    zh: '所有銀行代碼與機構資訊均來自台灣官方金融監管機構，包括中華民國中央銀行與金融監督管理委員會。我們的資料庫定期更新，確保100%準確性與完整性。最後驗證日期：2026年3月。',
  },
  dataAccuracy: {
    en: '✓ Official verification from Central Bank of Taiwan  ✓ Monthly updates  ✓ 410 institutions verified  ✓ Compliance with Taiwan banking standards',
    zh: '✓ 中央銀行官方驗證  ✓ 每月更新  ✓ 410家機構已驗證  ✓ 符合台灣銀行業標準',
  },

  // Use Cases
  useCasesTitle: {
    en: 'Common Use Cases',
    zh: '常見使用情境',
  },
  useCase1: {
    en: '💳 Bank Transfers: Find correct bank codes for domestic wire transfers and ACH payments',
    zh: '💳 銀行轉帳：查找正確的銀行代碼進行國內匯款與 ACH 轉帳',
  },
  useCase2: {
    en: '📄 Payment Processing: Verify bank codes for invoice payments and supplier transactions',
    zh: '📄 付款處理：驗證銀行代碼用於發票付款與供應商交易',
  },
  useCase3: {
    en: '💻 Software Development: Integrate Taiwan bank code data into FinTech applications and banking systems',
    zh: '💻 軟體開發：將台灣銀行代碼資料整合至金融科技應用與銀行系統',
  },
  useCase4: {
    en: '🌾 Agricultural Finance: Access farmers\' association credit departments for rural banking needs',
    zh: '🌾 農業金融：查詢農會信用部資訊，滿足農村金融需求',
  },
  useCase5: {
    en: '🎣 Fishery Finance: Find fishermen\'s association credit departments for coastal community banking',
    zh: '🎣 漁業金融：查找漁會信用部資訊，服務沿海社區銀行業務',
  },

  // Footer - Enhanced
  footerCopyright: {
    en: `© 2024-${new Date().getFullYear()} Taiwan Bank Code Directory. All Rights Reserved.`,
    zh: `© 2024-${new Date().getFullYear()} 台灣銀行代碼查詢系統。版權所有。`,
  },
  footerDisclaimer: {
    en: 'Information provided for reference purposes only. For official transactions, please verify bank codes directly with the respective financial institutions or the Central Bank of Taiwan. We strive for accuracy but cannot guarantee real-time updates for all institutional changes.',
    zh: '本站資訊僅供參考。進行正式交易時，請直接向相關金融機構或中華民國中央銀行核實銀行代碼。我們致力於提供準確資訊，但無法保證所有機構變更的即時更新。',
  },
  footerMadeBy: {
    en: 'Developed with',
    zh: '用心開發於',
  },
  footerCompany: {
    en: 'Homy Tech',
    zh: 'Homy Tech',
  },
  footerCompanyUrl: {
    en: 'https://homy.hk/',
    zh: 'https://homy.hk/',
  },
  footerLinks: {
    en: 'Quick Links',
    zh: '快速連結',
  },
  footerPrivacy: {
    en: 'Privacy Policy',
    zh: '隱私權政策',
  },
  footerTerms: {
    en: 'Terms of Service',
    zh: '服務條款',
  },
  footerContact: {
    en: 'Contact Us',
    zh: '聯絡我們',
  },
  footerLastUpdated: {
    en: 'Last Updated: March 2026',
    zh: '最後更新：2026年3月',
  },
  footerInstitutionCount: {
    en: '410 Taiwan Financial Institutions',
    zh: '410家台灣金融機構',
  },
  
  // SEO-friendly keywords for AI search
  seoKeywords: {
    en: [
      'Taiwan bank codes',
      'bank code lookup Taiwan',
      'financial institution codes',
      'Taiwan banking directory',
      'SWIFT codes Taiwan',
      'clearing codes',
      'farmers association credit',
      'fishermen association credit',
      'credit cooperatives Taiwan',
      'digital banks Taiwan',
      'Taiwan Central Bank codes',
      'agricultural finance Taiwan',
      'fishery finance Taiwan',
      'bank transfer codes',
      'ACH payment codes Taiwan'
    ],
    zh: [
      '台灣銀行代碼',
      '銀行代碼查詢',
      '金融機構代碼',
      '銀行代碼大全',
      'SWIFT代碼',
      '清算代碼',
      '農會信用部',
      '漁會信用部',
      '信用合作社',
      '數位銀行',
      '中央銀行代碼',
      '農業金融',
      '漁業金融',
      '匯款代碼',
      '轉帳代碼'
    ]
  }
};